(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mmm-wholesale"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement only. All links and FAQs work without this script.
  // The optional mobile bar stays hidden if observers are unavailable, while
  // editing, and as soon as the application area approaches the viewport.
  if (!customElements.get('mmm-wholesale-page')) {
    class MMMWholesalePage extends HTMLElement {
      connectedCallback() {
        // Defer until this element's children exist, including theme-editor reloads.
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.bar = this.querySelector('[data-wholesale-sticky]');
        const hero = this.querySelector('[data-wholesale-hero]');
        const application = this.querySelector('[data-wholesale-application]');
        if (!this.bar || !hero || !application || this.dataIsEditor() || !('IntersectionObserver' in window)) return;
        this.heroPassed = false;
        this.applicationReached = false;
        this.heroObserver = new IntersectionObserver((entries) => {
          this.heroPassed = entries[0].boundingClientRect.bottom < 0;
          this.updateBar();
        }, { threshold: 0 });
        this.applicationObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.applicationReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
          this.updateBar();
        }, { rootMargin: '0px 0px 120px 0px', threshold: 0 });
        this.heroObserver.observe(hero);
        this.applicationObserver.observe(application);
      }
      dataIsEditor() { return this.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode); }
      updateBar() { if (this.bar) this.bar.hidden = !(this.heroPassed && !this.applicationReached); }
      disconnectedCallback() {
        if (this.initFrame) cancelAnimationFrame(this.initFrame);
        if (this.heroObserver) this.heroObserver.disconnect();
        if (this.applicationObserver) this.applicationObserver.disconnect();
      }
    }
    customElements.define('mmm-wholesale-page', MMMWholesalePage);
  }

  } catch(e) { console.error(e); }
})();
})();
